import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import { Reveal } from "./common";

const PROPERTY = new Set(["commercial-mortgages", "btl-mortgages", "bridging-finance", "development-finance"]);

export function RelatedGuides({ slug, title }) {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => setPosts([]));
  }, []);

  const category = PROPERTY.has(slug) ? "Property" : "Business Finance";
  const ranked = [
    ...posts.filter((p) => p.cta_slug === slug),
    ...posts.filter((p) => p.cta_slug !== slug && p.category === category),
    ...posts.filter((p) => p.cta_slug !== slug && p.category !== category),
  ].slice(0, 3);

  if (!ranked.length) return null;

  return (
    <section data-testid="related-guides" className="border-t border-[#808080]/20">
      <div className="container-x mx-auto max-w-[1400px] py-24">
        <Reveal className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-12">
          <div>
            <span className="text-xs uppercase tracking-[0.3em] text-lime">Knowledge Hub</span>
            <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mt-4">{title} guides</h2>
          </div>
          <Link to="/knowledge-hub" data-testid="related-guides-all" className="inline-flex items-center gap-2 text-grey hover:text-lime transition-colors text-sm">All guides <ArrowRight className="w-4 h-4" /></Link>
        </Reveal>
        <div className="grid md:grid-cols-3 gap-6">
          {ranked.map((p, i) => (
            <Reveal key={p.slug} delay={i * 0.08}>
              <Link to={`/knowledge-hub/${p.slug}`} data-testid={`related-guide-${p.slug}`} className="group block border border-[#808080]/20 hover:border-lime/40 transition-colors h-full">
                <div className="h-44 overflow-hidden">
                  <img src={p.image} alt={p.title} loading="lazy" className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500" />
                </div>
                <div className="p-6">
                  <span className="text-xs uppercase tracking-widest text-lime">{p.category}</span>
                  <h3 className="text-lg font-bold mt-3 group-hover:text-lime transition-colors leading-snug">{p.title}</h3>
                  <p className="text-grey text-sm mt-3 line-clamp-2">{p.excerpt}</p>
                  <p className="text-xs text-grey mt-4">{p.read_time}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
